module.exports = __webpack_public_path__ + "static/media/features-split-top-01.043c6c00.png";